/// <reference path="../_references.js" />

function mStateManagerStats_Init(aPrevious, aCurrent) {
    "use strict";
    var lLayout = aCurrent.Tab + '.Layout.htm';
    populateElement('uMasterContentHolder', lLayout, mStateManagerStats_OnComplete);
}

function statsDisplayItem(aCacheItem) {
    "use strict";
    var lHtml = [],
        lStats,
        lItem,
        lKey;

    lHtml.push('<h2>');
    lHtml.push(aCacheItem.Name);
    lHtml.push('</h2>');
    lHtml.push('<table border="0" style="border-collapse:collapse; margin: 8px 0;">');
    lStats = aCacheItem.getStatistics();
    for (lKey in lStats) {
        if (lStats.hasOwnProperty(lKey)) {
            lItem = lStats[lKey];
            lHtml.push('<tr style="border-bottom: 1px solid black;">');
            lHtml.push('<td style="width: 150px;">');
            lHtml.push(DisplayShortDateTime(new Date(parseInt(lKey))));
            lHtml.push('</td>');
            lHtml.push('<td style="width: 75px;');
            if (lItem.timeSpan > 500) {
                lHtml.push('color: red;font-weight: bold;');
            }
            lHtml.push('">');
            lHtml.push(lItem.timeSpan);
            lHtml.push('ms');
            lHtml.push('</td>');
            lHtml.push('<td style="padding-right: 15px;">');
            lHtml.push(lItem.itemCount);
            lHtml.push(' items</td>');
            lHtml.push('</tr>');
        }
    }
    lHtml.push('</table>');

    return lHtml.join('');
}

function stats_OnUpdate(aSender, aCacheItem, aParams) {
    "use strict";
    $('#uStatistic' + aCacheItem.Name).html(statsDisplayItem(aCacheItem));
    veritracks.security.controller.extendSession();
}

function mStateManagerStats_OnComplete() {
    "use strict";
    var lHtml = [],
        lUpdatable = mCache.getUpdatableItems(),
        lSpanList,
        lSpanItem,
        lSpanKey,
        lItem,
        lKey;

    $('#uMasterMenuPanel').show();
    resetContentHolders();
    for (lKey in lUpdatable) {
        if (lUpdatable.hasOwnProperty(lKey)) {
            lItem = lUpdatable[lKey];
            if (!isNullOrUndefined(lItem)) {
                lHtml.push('<div id="uStatistic');
                lHtml.push(lItem.Name);
                lHtml.push('">');
                lHtml.push(statsDisplayItem(lItem));
                lHtml.push('</div>');

                mCache.bind(lItem.Name + 'complete', stats_OnUpdate);
            }
        }
    }
    $('#uStatsHolder').html(lHtml.join(''));
}

function mStateManagerStats_Leave() {
    "use strict";
    var lUpdatable = mCache.getUpdatableItems(),
        lItem,
        lKey;

    for (lKey in lUpdatable) {
        if (lUpdatable.hasOwnProperty(lKey)) {
            lItem = lUpdatable[lKey];
            if (!isNullOrUndefined(lItem)) {
                mCache.unbind(lItem.Name + 'complete', stats_OnUpdate);
            }
        }
    }
}